
import debug from 'debug';

const log = debug('app:log');
const warn = debug('app:warn');
const error = debug('app:error');

const logger = {
  log: (message: string, ...args: unknown[]) => log(message, ...args),
  warn: (message: string, ...args: unknown[]) => warn(message, ...args),
  error: (message: string, ...args: unknown[]) => error(message, ...args),
};

export default logger;